import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

import { Text } from "../../../shared/uiComponents";
import { HeaderWrapper } from "./helpers";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { getSessionInfo } from "../../../redux/State/clientSlice/sessionSlice";
import { findSoapNoteTamplate } from "../../SOAPNote";

const EditSoapNote = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const [params] = useSearchParams();

  const { client, date, sessionType } = useSelector((state) => state.session.sessionInfo);
  const supervisor = useSelector((state) => state.soapNote.soapNoteData.supervisor);

  useEffect(() => {
    const sessionId = params.get("sessionId");
    if (!sessionId) return;

    dispatch(getSessionInfo(sessionId));
  }, [params, dispatch]);

  return (
    <div className="container" style={{ flexDirection: "column", maxWidth: "900px" }}>
      <HeaderWrapper className="title marginBottom16">
        <Text title="SOAP Note" size="mediumBold" />
        {!!date && <Text title={`Date: ${dayjs(date).format("MM/DD/YYYY")}`} />}
        {!!client && <Text title={client.fullName} size="smallBold" />}
        {!!supervisor?.id && <Text title={`Supervisor: ${supervisor.fullName}`} size="smallBold" />}
      </HeaderWrapper>
      {!!sessionType.id && (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Text title={"Service: "} size={"mediumBold"} />
          <Text title={sessionType.name} size="medium" />
        </div>
      )}
      <div className="marginBottom16" />
      {findSoapNoteTamplate(sessionType.type)}
    </div>
  );
};

export default EditSoapNote;
